import type { TabKey } from '@/components/base/BaseTab.vue'

export default function useTabletPageTabs() {
  const { t } = useI18n()
  const route = useRoute()

  const currentTab = ref((route?.query?.activeTab as string) || 'tablets')
  const tabs = ref<TabKey[]>([
    {
      value: 'tablets',
      name: t('pages.loyaltySupports.tablets.tabs.tablets'),
      icon: 'HeroDeviceTabletIconOutline'
    },
    {
      value: 'appearance',
      name: t('pages.loyaltySupports.tablets.tabs.appearance'),
      icon: 'HeroPaintBrushIconOutline'
    },
    {
      value: 'texts',
      name: t('pages.loyaltySupports.tablets.tabs.texts'),
      icon: 'HeroClipboardDocumentListIconOutline'
    },
    {
      value: 'config',
      name: t('pages.loyaltySupports.tablets.tabs.config'),
      icon: 'HeroCog8ToothIconOutline'
    }
  ])

  return {
    tabs,
    currentTab
  }
}
